// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".szjYhJ56TZThJH {\n  display: inline;\n  border-radius: 3px;\n  background-color: var(--ds-background-accent-gray-subtler, rgba(255, 255, 255, 0.69));\n  padding: 3px 8px;\n  font-size: 11px;\n  font-weight: bold;\n  line-height: 16px;\n  align-items: center;\n  color: var(--ds-text, #172B4D);\n  width: fit-content;\n  width: -moz-fit-content;\n}\n._2JwlycylilXGY {\n  background-color: var(--dynamic-nav-item-pressed);\n  color: var(--dynamic-text);\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardTemplateBadge": "szjYhJ56TZThJH",
	"transparent": "_2JwlycylilXGY"
};
export default ___CSS_LOADER_EXPORT___;
